import isEqual from 'lodash/isEqual';
import type { Action } from 'react-sweet-state';
import type { ProjectContext } from '@atlassian/jira-providers-project-context/src/types';
import type { State } from '../types';

export const setProjectContext =
	(projectContext: ProjectContext): Action<State> =>
	({ getState, setState }) => {
		const { projectContext: currentProjectContext } = getState();
		if (!isEqual(currentProjectContext, projectContext)) {
			setState({ projectContext });
		}
	};

export const setShowingAllRepositories =
	(showingAllRepositories: boolean): Action<State> =>
	({ getState, setState }) => {
		const { showingAllRepositories: currentShowAllRepositories } = getState();
		if (!isEqual(currentShowAllRepositories, showingAllRepositories)) {
			setState({ showingAllRepositories });
		}
	};
